<script>
  export let url = undefined;
  export let newWindow = false;
</script>

<style>
a {
  color: inherit;
  text-decoration: none;
}
</style>


<a href={url} target={newWindow ? '_blank' : '_self'} on:click tinro-ignore>
  <slot></slot>
</a>